import React from 'react';
import { Translation } from 'react-i18next';

function FormTitle({ title }) {
  return <Translation>{t => <span>{t(title)}</span>}</Translation>;
}

export default FormTitle;



// WEBPACK FOOTER //
// ./src/view/scenes/components/FormTitle.jsx